import { useState, useEffect } from "react";
import AlertCircle from "react-feather/dist/icons/alert-circle";
import Modal from "react-responsive-modal";

import style from "./style.module.scss";
import getImageSize from "../../utils/image-size";

const SIZE_THRESHOLD = 20 * 20 * 300;

interface ImageSizeIndicatorProps {
  src: string | null | undefined;
  className?: string;
}

function ImageSizeIndicator({ src, className }: ImageSizeIndicatorProps) {
  const [showWarning, setShowWarning] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setShowWarning(false);

    if (!src) {
      return;
    }

    getImageSize(src).then(({ width, height }) => {
      if (cancelled) {
        return;
      }

      if (width * height < SIZE_THRESHOLD) {
        setShowWarning(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [src]);

  const onOpenModal = () => {
    setShowModal(true);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  if (!showWarning) {
    return null;
  }

  return (
    <div className={className}>
      <button
        title="Attention à la qualité de la photo"
        onClick={onOpenModal}
        className={style.button}
      >
        <AlertCircle />
      </button>
      <Modal open={showModal} onClose={onCloseModal}>
        <h2 className={style.modalTitle}>Attention à la qualité de le photo</h2>
        <p>Pour une impression optimale, une photo avec grande résolution est préfèrable.</p>
        <p>Aussi, pensez à éviter les photos sombres ou floues.</p>
      </Modal>
    </div>
  );
}

export default ImageSizeIndicator;
